export default {
	title: "Veille",
	url: "veille",
	subtitle: "Rapport de veille stratégique généré par recherche anonymisée : le sujet du projet est neutralisé avant tout appel à des sources publiques. Le rapport couvre le contexte macro (PESTEL), sectoriel (5 forces de Porter) et interne, avec signaux forts et faibles.",
	current: "Rapport actuel",
	archive: "Archives",
	context_tab: "Contexte",
	empty: "Aucun rapport de veille pour ce projet.",
	generated_on: "Établi le",
	impact_tab_tooltip: "Analyse de l'impact sur votre projet et génération de scénario",
	impact_tab: "Impact projet",
	impact_description: "Générez un scénario stratégique basé sur les tendances identifiées dans ce rapport de veille.",
	actions: {
		generate: "Générer un rapport",
		generate_new: "Générer un nouveau rapport",
		generating: "Génération en cours… (une dizaine de minutes)",
		retry: "Réessayer",
		print: "Imprimer",
		delete: "Supprimer ce rapport",
		delete_confirm: "Supprimer définitivement ce rapport ?",
		generate_scenario: "Générer un scénario à partir de ce rapport"
	},
	steps: {
		anonymizing: "Anonymisation du sujet",
		researching: "Recherche et rédaction",
		done: "Rapport disponible",
		elapsed: "depuis {{minutes}} min"
	},
	messages: {
		failed: "La génération a échoué",
		neutral_subject: "Sujet anonymisé envoyé",
		confirm_title: "Lancer une veille anonymisée ?",
		confirm_body: "Le sujet du projet sera anonymisé avant toute recherche sur des sources publiques. La génération du rapport prend une dizaine de minutes.",
		context_label: "Angles spécifiques à couvrir (optionnel)",
		context_placeholder: "Ex : impact sur nos partenaires européens, évolutions réglementaires…",
		context_hint: "Ce texte est aussi anonymisé avant d'être transmis.",
		attachments_label: "Documents internes du projet (optionnel)",
		attachments_hint: "Les documents ajoutés ici sont analysés en privé par l'IA, sans quitter votre compte AWS."
	}
};
